import { render } from "./WidgetEndpoints.vue?vue&type=template&id=44fa6187&scoped=true"
import script from "./WidgetEndpoints.vue?vue&type=script&lang=js"
export * from "./WidgetEndpoints.vue?vue&type=script&lang=js"

import "./WidgetEndpoints.vue?vue&type=style&index=0&id=44fa6187&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fa6187"]])

export default __exports__